import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebookF,
  faTwitter,
  faInstagram,
  faLinkedinIn,
} from "@fortawesome/free-brands-svg-icons";
import { faPhoneAlt, faEnvelope } from "@fortawesome/free-solid-svg-icons";

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-300 px-4 pt-12 pb-6">
      <div className="container mx-auto px-4">
        {/* Main Footer Content - 5 columns on md+ */}
        <div className="grid grid-cols-1 md:grid-cols-5 gap-8 mb-8">
          {/* Branding */}
          <div className="md:col-span-1">
            <h3 className="text-white text-lg font-semibold mb-3">
              SPK Academy & Publishing
            </h3>
            <p className="text-sm leading-relaxed">
              Education remains the most potent, the most available and the most
              viable way to provide soft skills needed to navigate life.
            </p>
          </div>

          {/* Contact */}
          <div className="md:col-span-1">
            <h4 className="text-white text-md font-semibold mb-3">Contact Us</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <FontAwesomeIcon icon={faPhoneAlt} className="mr-2 text-blue-400" />
                (+27) 84 611 4384, (+27) 68 124 7577
              </li>
              <li>
                <FontAwesomeIcon icon={faEnvelope} className="mr-2 text-blue-400" />
                secretariatebusiness@gmail.com
              </li>
              <li>1667 Kameeldoorn Street</li>
              <li>Hoopstad 9479</li>
            </ul>
          </div>

          {/* Social Media */}
          <div className="md:col-span-1">
            <h4 className="text-white text-md font-semibold mb-3">Follow Us</h4>
            <div className="flex space-x-4">
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-white transition"
              >
                <FontAwesomeIcon icon={faFacebookF} />
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-white transition"
              >
                <FontAwesomeIcon icon={faTwitter} />
              </a>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-white transition"
              >
                <FontAwesomeIcon icon={faInstagram} />
              </a>
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-white transition"
              >
                <FontAwesomeIcon icon={faLinkedinIn} />
              </a>
            </div>
          </div>

          {/* Legal Links */}
          <div className="md:col-span-1">
            <h4 className="text-white text-md font-semibold mb-3">Legal</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/privacy-policy" className="hover:underline hover:text-white">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms-of-service" className="hover:underline hover:text-white">
                  Terms of Service
                </Link>
              </li>
            </ul>
          </div>

          {/* Navigation (from new footer) */}
          <div className="md:col-span-1">
            <h4 className="text-white text-md font-semibold mb-3">Explore</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/services" className="hover:underline hover:text-white">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/about" className="hover:underline hover:text-white">
                  About
                </Link>
              </li>
              <li>
                <Link to="/contacts" className="hover:underline hover:text-white">
                  Contacts
                </Link>
              </li>
              <li>
                <Link to="/books" className="hover:underline hover:text-white">
                  Books
                </Link>
              </li>
              <li>
                <Link to="/classes" className="hover:underline hover:text-white">
                  Classes
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Copyright */}
        <div className="border-t border-gray-800 pt-6 text-sm text-center md:text-left">
          <p>
            &copy; {new Date().getFullYear()} SPK Academy & Publishing. All rights
            reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;